/* global primitives */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Paper, LinearProgress } from 'material-ui';
import { connect } from 'react-redux';
import $ from 'jquery';
import { isEmpty, map } from 'lodash';

import '../orgchart/primitives';
import '../styles/primitives.css';
import '../styles/orgChartCustomStyles.css';
import {
  generateEmployeeTemplate,
  generateCompanyTemplate,
  generateHighlightTemplate,
} from '../utils/orgChart';
import pallet from '../constants/colors';
import { fetchData } from '../actions/EmployeeOrgChart';

const {
  TemplateConfig, Config, ItemConfig, UpdateMode,
} = primitives.orgdiagram;
const {
  Size, Thickness, GraphicsType, PlacementType, Enabled, ChildrenPlacementType: { Matrix, Horizontal },
} = primitives.common;

const styles = {
  diagram: {
    width: '100%',
    height: '100%',
    outlineWidth: 0,
    overflow: 'hidden',
  },
  paper: {
    overflow: 'hidden',
    padding: 16,
    margin: 16,
    height: '100%',
  },
  errorMessage: {
    textAlign: 'center',
    padding: 24,
    textTransform: 'uppercase',
    fontWeight: 500,
    color: pallet.errorColor,
  },
};

// https://www.basicprimitives.com/index.php?option=com_local&view=local&Itemid=43&lang=en#primitives.orgdiagram.TemplateConfig
const getCompanyTemplate = () => {
  const template = new TemplateConfig({
    name: 'companyTemplate',
    itemSize: new Size(150, 77),
    minimizedItemSize: new Size(15, 15),
    highlightPadding: new Thickness(0, 0, 0, 0),
    cursorPadding: new Thickness(0, 0, 0, 0),
  });
  template.itemTemplate = generateCompanyTemplate(template, 'business');
  template.highlightTemplate = generateHighlightTemplate(template);
  return template;
};

const getCompanyUnitTemplate = () => {
  const template = new TemplateConfig({
    name: 'companyUnitTemplate',
    itemSize: new Size(150, 77),
    minimizedItemSize: new Size(10, 10),
    highlightPadding: new Thickness(0, 0, 0, 0),
    cursorPadding: new Thickness(0, 0, 0, 0),
  });
  template.itemTemplate = generateCompanyTemplate(template, 'group');
  template.highlightTemplate = generateHighlightTemplate(template);
  return template;
};

const getEmployeeTemplate = () => {
  const template = new TemplateConfig({
    name: 'employeeTemplate',
    itemSize: new Size(200, 105),
    highlightPadding: new Thickness(0, 0, 0, 0),
    cursorPadding: new Thickness(0, 0, 0, 0),
  });
  template.itemTemplate = generateEmployeeTemplate(template);
  template.highlightTemplate = generateHighlightTemplate(template);
  return template;
};

// update fields on initial render, on resize, on update
function onTemplateRender(event, data) {
  const { context, templateName, element } = data;
  const fields = ['title'];
  if (templateName === 'employeeTemplate') fields.push('description', 'phone', 'email');

  fields.forEach((field) => {
    const el = element.find(`[name=${field}]`);
    if (el.text() !== context[field]) {
      el.text(context[field]);
      el[0].setAttribute('title', context[field]);
    }
  });
}

// https://www.basicprimitives.com/index.php?option=com_local&view=local&Itemid=43&lang=en#primitives.orgdiagram.Config
const configureDiagram = (items, cursorItem) => {
  let options = new Config();
  options = {
    ...options,
    items,
    enablePanning: !navigator.userAgent.includes('Safari'), // Safari only not support panning (2016)
    hasButtons: false,
    // NOTE: This might have to change for different browsers (to Canvar / VML see basicprimitives documentation)
    graphicsType: GraphicsType.SVG,
    placementType: PlacementType.Bottom,
    templates: [getCompanyTemplate(), getCompanyUnitTemplate(), getEmployeeTemplate()],
    hasSelectorCheckbox: Enabled.False,
    cursorItem,
    onItemRender: onTemplateRender,
    normalLevelShift: 25,
    normalItemsInterval: 25,
    dotLevelShift: 35,
    dotItemsInterval: 8,
    lineLevelShift: 10,
    lineItemsInterval: 5,
  };
  return options;
};

const EmployeeOrgChart = ({
  data,
  dispatch,
  isFetching,
  cursorItem,
  error,
}) => {

  const adjustPlaceholder = () => {
    const bodyWidth = $(window).width() - 64;
    const bodyHeight = $(window).height() - 180;
    $('#orgdiagram').css({
      width: `${bodyWidth}px`,
      height: `${bodyHeight}px`,
      transform: 'translateZ(0)',
    });
  };

  const onWindowResize = () => {
    adjustPlaceholder();
    $('#orgdiagram').orgDiagram('update', UpdateMode.Refresh);
  };

  useEffect(() => {
    dispatch(fetchData());
    adjustPlaceholder();
    window.addEventListener('resize', onWindowResize);
    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, []);

  if (!isFetching && !isEmpty(data)) {
    const items = map(data, d => new ItemConfig({
      ...d,
      childrenPlacementType: d.setChildrenMatrix ? Matrix : Horizontal,
    }));
    const config = configureDiagram(items, cursorItem);
    $('#orgdiagram').orgDiagram(config); // DOM must be rendered to call this method!
  }

  return (
    <Paper style={styles.paper}>
      {error && <div style={styles.errorMessage}>{`Ekki tókst að birta gögnin: ${error.Message}`}</div>}
      {isFetching && <LinearProgress mode="indeterminate" />}
      <div id="orgdiagram" style={styles.diagram} />
    </Paper>
  );
};

EmployeeOrgChart.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.array,
  isFetching: PropTypes.bool,
  cursorItem: PropTypes.number,
  error: PropTypes.object,
};

const mapStateToProps = state => ({
  data: state.EmployeeOrgChart.data,
  isFetching: state.EmployeeOrgChart.isFetching,
  cursorItem: state.EmployeeOrgChart.cursorItem,
});

export default connect(mapStateToProps)(EmployeeOrgChart);



// WEBPACK FOOTER //
// ./src/containers/EmployeeOrgChart.js